import React from "react";
import { useDocumentTitle } from "../../../hooks/customDocumentTitleHook";
import { Config } from "../../../Config";
import { ArrowDownToLine } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function FormsPDFView() {
  const { pathname } = useLocation();
  let pdfName = "";
  let pdfTitle = "";

  switch (pathname) {
    case "/forms/advanced-directive-form":
      pdfName = "Advanced-Directive-Form.pdf";
      pdfTitle = "Advanced Directive Form";
      break;
    case "/forms/hipaa-consent-form":
      pdfName = "HIPAA-Consent-Form.pdf";
      pdfTitle = "HIPAA Consent Form";
      break;
    case "/forms/older-care-form":
      pdfName = "Older-Care-Form.pdf";
      pdfTitle = "Older Care Form";
      break;
    case "/forms/patient-intake-form":
      pdfName = "Patient-Intake-Form.pdf";
      pdfTitle = "Patient Intake Form";
      break;
    case "/forms/patient-survey-form":
      pdfName = "Patient-Survey-Form.pdf";
      pdfTitle = "Patient Survey Form";
      break;
    case "/forms/dot-physical-form":
      pdfName = "DOT-Physical-Form.pdf";
      pdfTitle = "DOT Physical Form";
      break;
    case "/forms/care-plan-form":
      pdfName = "Care-Plan-Form.pdf";
      pdfTitle = "Care Plan Form";
      break;
    case "/forms/community-assessment-form":
      pdfName = "Community-Assesment-Form.pdf";
      pdfTitle = "Community Assesment Form";
      break;
    case "/forms/immunization-form":
      pdfName = "Immunization-Form.pdf";
      pdfTitle = "Immunization Form";
      break;
    default:
      pdfName = "";
      pdfTitle = "";
      break;
  }

  useDocumentTitle(`${pdfTitle}`);

  return (
    <>
      <style>
        {`
          .docpro_copyright {
            display: none;
          }
          iframe {
            display: block;
            height: 88vh;
            width: 100%;
            border: none;
            border-radius: 12px;
          }
        `}
      </style>
      <div className="mb-1 pb-1 relative">
        <iframe 
          src={`https://flowpaper.com/flipbook/${Config.appUrl}/form_pdfs/${pdfName}`}
          width="100%"
          height="100%"
          allowFullScreen
          title={pdfTitle}
          loading="lazy"
          referrerPolicy="origin"
        ></iframe>

        <div className="absolute" style={{ top: '15px', right: '10px' }}>
          <a href={`${Config.appUrl}/form_pdfs/${pdfName}`}
            target="_blank"
            rel="noopener noreferrer"
            download={pdfName}
            className="docpro_icon_btn last_btn_tip" 
            style={{ padding: '12px', background: '#1578d5', borderRadius: '5px', color: '#ffffff' }}
          >
            <ArrowDownToLine width={20} height={20} />
            <span className="docpro_tip">Download Form</span>
          </a>
        </div>
      </div>
    </>
  );
}
